import * as i0 from '@angular/core';
import { EventEmitter, ViewChild, Output, Input, ViewEncapsulation, Component, NgModule, ChangeDetectionStrategy } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, delay } from 'rxjs/operators';
import * as i4 from '@watchguard/wg-ng-core';
import { WgIconModule, WgClickOutsideModule, WgDropdownModule, WgDialogModule } from '@watchguard/wg-ng-core';
import * as i5 from '@watchguard/wg-datetimepicker';
import { WgDateTimePickerModule } from '@watchguard/wg-datetimepicker';
import moment from 'moment';
import { flatten } from 'underscore';

/**
 * @license
 * Copyright WatchGuard Technologies Inc. All Rights Reserved.
 *
 * This library does filtering of objects based on a supplied text input from user
 *
 * Searchbox component
 * Filters a key-value pair object or an array of objects
 * When the component is used need to specify which keys to filter
 * Outputs an array of objects that contain the key specified by component definition and value entered in the search box
 * Example usage:
 * <wg-search
 *    [title]="title"
 *    [placeholder]="title"
 *    [initObjects]="initDevices"
 *    [filterKeys]="filterKeys"
 *    (filterObjects)="filterDevices($event)"
 *    (keydown.enter)="submit($event)">
 * </wg-search>
 */
/** Searchbox component
 * Filters a key-value pair object or an array of objects
 * When the component is used need to specify which keys to filter
 * Outputs an array of objects that contain the key specified by component definition and value entered in the search box
 * Example usage:
 * <wg-search
 *    [title]="title"
 *    [placeholder]="title"
 *    [initObjects]="initDevices"
 *    [filterKeys]="filterKeys"
 *    (filterObjects)="filterDevices($event)"
 *    (keydown.enter)="submit($event)">
 * </wg-search>
 **/
// export class WgSearchComponent implements OnInit {
const _c0 = ["dropdownMenu"];
const _c1 = ["searchbox"];
const _c2 = (a0, a1) => ({
  "wg-dropdown dropdown": a0,
  "search-icon-clickable": a1
});
const _c3 = a0 => ({
  show: a0
});
const _c4 = a0 => ({
  hover: a0
});
function WgSearchComponent_span_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 12)(1, "button", 13);
    i0.ɵɵlistener("click", function WgSearchComponent_span_13_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleTypeaheadHelp());
    });
    i0.ɵɵelement(2, "wg-icon", 14);
    i0.ɵɵelementEnd()();
  }
}
function WgSearchComponent_div_14_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵlistener("mousedown", function WgSearchComponent_div_14_a_2_Template_a_mousedown_0_listener($event) {
      const item_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.itemSelected($event, item_r5));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c4, i_r6 === ctx_r2.itemHoveredIndex));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r5, " ");
  }
}
function WgSearchComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15, 1);
    i0.ɵɵtemplate(2, WgSearchComponent_div_14_a_2_Template, 2, 4, "a", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, ctx_r2.showSuggestion));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.items);
  }
}
function WgAdvancedFilterChipsComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "a", 3);
    i0.ɵɵlistener("click", function WgAdvancedFilterChipsComponent_span_1_Template_a_click_2_listener() {
      const chip_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.removeFilter(chip_r2));
    });
    i0.ɵɵelement(3, "wg-icon", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const chip_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", chip_r2.label, " ");
  }
}
const _c5 = ["filterForm"];
const _c6 = (a0, a1, a2) => ({
  group: a0,
  category: a1,
  filter: a2
});
const _c7 = a0 => [a0];
function WgAdvancedFilterComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "wg-icon", 19);
    i0.ɵɵelementContainerEnd();
  }
}
function WgAdvancedFilterComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.labelText);
  }
}
function WgAdvancedFilterComponent_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgAdvancedFilterComponent_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgAdvancedFilterComponent_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgAdvancedFilterComponent_ng_template_15_div_0_h5_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, group_r3.name));
  }
}
function WgAdvancedFilterComponent_ng_template_15_div_0_div_2_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectedFilters_r6 = ctx.ngIf;
    i0.ɵɵproperty("title", selectedFilters_r6);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", selectedFilters_r6, " ");
  }
}
function WgAdvancedFilterComponent_ng_template_15_div_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵlistener("click", function WgAdvancedFilterComponent_ng_template_15_div_0_div_2_Template_div_click_0_listener() {
      const category_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.openCategory(category_r5));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, WgAdvancedFilterComponent_ng_template_15_div_0_div_2_div_3_Template, 2, 2, "div", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const category_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("opened", category_r5 === ctx_r1.openedCategory);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, category_r5.name), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.categoryFilters(category_r5));
  }
}
function WgAdvancedFilterComponent_ng_template_15_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, WgAdvancedFilterComponent_ng_template_15_div_0_h5_1_Template, 3, 3, "h5", 21)(2, WgAdvancedFilterComponent_ng_template_15_div_0_div_2_Template, 4, 6, "div", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r3.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", group_r3.categories);
  }
}
function WgAdvancedFilterComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WgAdvancedFilterComponent_ng_template_15_div_0_Template, 3, 2, "div", 20);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r1.advancedFilterConfig == null ? null : ctx_r1.advancedFilterConfig.groups);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 30);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const categoryFilter_r7 = i0.ɵɵnextContext().$implicit;
    const category_r8 = i0.ɵɵnextContext().$implicit;
    const group_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext();
    const checkbox_r10 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", checkbox_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6, group_r9, category_r8, categoryFilter_r7));
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 30);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const categoryFilter_r7 = i0.ɵɵnextContext().$implicit;
    const category_r8 = i0.ɵɵnextContext().$implicit;
    const group_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext();
    const text_r11 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", text_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6, group_r9, category_r8, categoryFilter_r7));
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 30);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const categoryFilter_r7 = i0.ɵɵnextContext().$implicit;
    const category_r8 = i0.ɵɵnextContext().$implicit;
    const group_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext();
    const date_r12 = i0.ɵɵreference(12);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", date_r12)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6, group_r9, category_r8, categoryFilter_r7));
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_5_ng_container_1_Template, 1, 0, "ng-container", 30);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const categoryFilter_r7 = i0.ɵɵnextContext().$implicit;
    const category_r8 = i0.ɵɵnextContext().$implicit;
    const group_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext();
    const range_r13 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", range_r13)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6, group_r9, category_r8, categoryFilter_r7));
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_6_ng_container_1_Template, 1, 0, "ng-container", 30);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const categoryFilter_r7 = i0.ɵɵnextContext().$implicit;
    const category_r8 = i0.ɵɵnextContext().$implicit;
    const group_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext();
    const inputDropdownCombo_r14 = i0.ɵɵreference(10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", inputDropdownCombo_r14)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6, group_r9, category_r8, categoryFilter_r7));
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 28);
    i0.ɵɵtemplate(2, WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_2_Template, 2, 6, "ng-container", 29)(3, WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_3_Template, 2, 6, "ng-container", 29)(4, WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_4_Template, 2, 6, "ng-container", 29)(5, WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_5_Template, 2, 6, "ng-container", 29)(6, WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_ng_container_6_Template, 2, 6, "ng-container", 29);
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const categoryFilter_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", categoryFilter_r7.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.filterType.checkbox);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.filterType.text);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.filterType.date);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.filterType.range);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.filterType.inputDropdownCombo);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtemplate(2, WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_ng_container_2_Template, 7, 6, "ng-container", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const category_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("display", category_r8 === ctx_r1.openedCategory ? "block" : "none");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", category_r8.filter);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WgAdvancedFilterComponent_ng_template_17_ng_container_2_ng_container_1_Template, 3, 3, "ng-container", 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const group_r9 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", group_r9.categories);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34)(1, "a", 35);
    i0.ɵɵlistener("click", function WgAdvancedFilterComponent_ng_template_17_ng_template_3_div_1_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r15);
      const filter_r16 = i0.ɵɵnextContext().filter;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setCategoryFilters(filter_r16.data, true));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 35);
    i0.ɵɵlistener("click", function WgAdvancedFilterComponent_ng_template_17_ng_template_3_div_1_Template_a_click_4_listener() {
      i0.ɵɵrestoreView(_r15);
      const filter_r16 = i0.ɵɵnextContext().filter;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setCategoryFilters(filter_r16.data, false));
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "select_all"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "clear_all"), " ");
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_3_div_2_wg_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "wg-icon", 41);
  }
  if (rf & 2) {
    let tmp_19_0;
    let tmp_20_0;
    const option_r18 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", option_r18.icon.name)("ngClass", i0.ɵɵpureFunction1(3, _c7, (tmp_19_0 = option_r18.icon.class) !== null && tmp_19_0 !== undefined ? tmp_19_0 : ""))("size", (tmp_20_0 = option_r18.icon.size) !== null && tmp_20_0 !== undefined ? tmp_20_0 : null);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_3_div_2_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 42);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r18 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, option_r18.tag));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, option_r18.tag), " ");
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36)(1, "label", 37);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "input", 38);
    i0.ɵɵtwoWayListener("ngModelChange", function WgAdvancedFilterComponent_ng_template_17_ng_template_3_div_2_Template_input_ngModelChange_3_listener($event) {
      const option_r18 = i0.ɵɵrestoreView(_r17).$implicit;
      i0.ɵɵtwoWayBindingSet(option_r18.checked, $event) || (option_r18.checked = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, WgAdvancedFilterComponent_ng_template_17_ng_template_3_div_2_wg_icon_4_Template, 1, 5, "wg-icon", 39);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtemplate(7, WgAdvancedFilterComponent_ng_template_17_ng_template_3_div_2_span_7_Template, 4, 6, "span", 40);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const option_r18 = ctx.$implicit;
    const filter_r16 = i0.ɵɵnextContext().filter;
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 6, option_r18.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", filter_r16.field + "_" + option_r18.value);
    i0.ɵɵtwoWayProperty("ngModel", option_r18.checked);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r18.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 8, option_r18.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", option_r18.tag);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵtemplate(1, WgAdvancedFilterComponent_ng_template_17_ng_template_3_div_1_Template, 7, 6, "div", 32)(2, WgAdvancedFilterComponent_ng_template_17_ng_template_3_div_2_Template, 8, 10, "div", 33);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filter_r16 = ctx.filter;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !filter_r16.hideCheckboxActions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", filter_r16.data);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43)(1, "label", 44);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 45);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function WgAdvancedFilterComponent_ng_template_17_ng_template_5_Template_input_ngModelChange_4_listener($event) {
      const filter_r20 = i0.ɵɵrestoreView(_r19).filter;
      i0.ɵɵtwoWayBindingSet(filter_r20.data, $event) || (filter_r20.data = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const category_r21 = ctx.category;
    const filter_r20 = ctx.filter;
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", filter_r20.field);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, "ui_common_search"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(5, 8, category_r21.name))("name", filter_r20.field)("id", filter_r20.field);
    i0.ɵɵtwoWayProperty("ngModel", filter_r20.data);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_7_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const filter_r23 = i0.ɵɵnextContext().filter;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, filter_r23.data.errorMessage), " ");
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_7_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const filter_r23 = i0.ɵɵnextContext().filter;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, filter_r23.data.errorMessage), " ");
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43)(1, "label", 44);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 46);
    i0.ɵɵtwoWayListener("ngModelChange", function WgAdvancedFilterComponent_ng_template_17_ng_template_7_Template_input_ngModelChange_4_listener($event) {
      const filter_r23 = i0.ɵɵrestoreView(_r22).filter;
      i0.ɵɵtwoWayBindingSet(filter_r23.data.rangeFrom, $event) || (filter_r23.data.rangeFrom = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function WgAdvancedFilterComponent_ng_template_17_ng_template_7_Template_input_ngModelChange_4_listener($event) {
      const filter_r23 = i0.ɵɵrestoreView(_r22).filter;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.validateInput($event, filter_r23.field + "_from"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, WgAdvancedFilterComponent_ng_template_17_ng_template_7_div_5_Template, 4, 3, "div", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 43)(7, "label", 44);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "input", 46);
    i0.ɵɵtwoWayListener("ngModelChange", function WgAdvancedFilterComponent_ng_template_17_ng_template_7_Template_input_ngModelChange_10_listener($event) {
      const filter_r23 = i0.ɵɵrestoreView(_r22).filter;
      i0.ɵɵtwoWayBindingSet(filter_r23.data.rangeTo, $event) || (filter_r23.data.rangeTo = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function WgAdvancedFilterComponent_ng_template_17_ng_template_7_Template_input_ngModelChange_10_listener($event) {
      const filter_r23 = i0.ɵɵrestoreView(_r22).filter;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.validateInput($event, filter_r23.field + "_to"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, WgAdvancedFilterComponent_ng_template_17_ng_template_7_div_11_Template, 4, 3, "div", 47);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_16_0;
    let tmp_23_0;
    const filter_r23 = ctx.filter;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", filter_r23.field);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 14, (tmp_16_0 = filter_r23.data.fromLabel) !== null && tmp_16_0 !== undefined ? tmp_16_0 : "ui_common_search"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", filter_r23.data.fromPlaceHolder)("name", filter_r23.field + "_from")("id", filter_r23.field);
    i0.ɵɵtwoWayProperty("ngModel", filter_r23.data.rangeFrom);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.validationErrors[filter_r23.field + "_from"] == null ? null : ctx_r1.validationErrors[filter_r23.field + "_from"].showError);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", filter_r23.field);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 16, (tmp_23_0 = filter_r23.data.toLabel) !== null && tmp_23_0 !== undefined ? tmp_23_0 : "ui_common_search"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", filter_r23.data.toPlaceHolder)("name", filter_r23.field + "_to")("id", filter_r23.field);
    i0.ɵɵtwoWayProperty("ngModel", filter_r23.data.rangeTo);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.validationErrors[filter_r23.field + "_to"] == null ? null : ctx_r1.validationErrors[filter_r23.field + "_to"].showError);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_9_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 53);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function WgAdvancedFilterComponent_ng_template_17_ng_template_9_Conditional_2_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r26);
      const filter_r25 = i0.ɵɵnextContext().filter;
      i0.ɵɵtwoWayBindingSet(filter_r25.data.inputData, $event) || (filter_r25.data.inputData = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function WgAdvancedFilterComponent_ng_template_17_ng_template_9_Conditional_2_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r26);
      const filter_r25 = i0.ɵɵnextContext().filter;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.validateTimeInput($event, filter_r25.field));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filter_r25 = i0.ɵɵnextContext().filter;
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(1, 4, filter_r25.field))("name", filter_r25.field)("id", filter_r25.field);
    i0.ɵɵtwoWayProperty("ngModel", filter_r25.data.inputData);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_9_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 52)(1, "input", 53);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function WgAdvancedFilterComponent_ng_template_17_ng_template_9_Conditional_3_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r27);
      const filter_r25 = i0.ɵɵnextContext().filter;
      i0.ɵɵtwoWayBindingSet(filter_r25.data.inputData, $event) || (filter_r25.data.inputData = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function WgAdvancedFilterComponent_ng_template_17_ng_template_9_Conditional_3_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r27);
      const filter_r25 = i0.ɵɵnextContext().filter;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.validateTimeInput($event, filter_r25.field));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "wg-dropdown", 54);
    i0.ɵɵlistener("selectedEvent", function WgAdvancedFilterComponent_ng_template_17_ng_template_9_Conditional_3_Template_wg_dropdown_selectedEvent_3_listener($event) {
      i0.ɵɵrestoreView(_r27);
      const filter_r25 = i0.ɵɵnextContext().filter;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectedDropdownItem($event, filter_r25.data.unitsData, "units"));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const filter_r25 = i0.ɵɵnextContext().filter;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(2, 6, filter_r25.field))("name", filter_r25.field)("id", filter_r25.field);
    i0.ɵɵtwoWayProperty("ngModel", filter_r25.data.inputData);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("dropdownList", filter_r25.data.unitsData)("userSelection", ctx_r1.selectedUnitValue ? ctx_r1.selectedUnitValue : filter_r25.data.unitsData[0]);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_9_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const filter_r25 = i0.ɵɵnextContext().filter;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, filter_r25.data.errorMessage), " ");
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 49)(1, "wg-dropdown", 50);
    i0.ɵɵlistener("selectedEvent", function WgAdvancedFilterComponent_ng_template_17_ng_template_9_Template_wg_dropdown_selectedEvent_1_listener($event) {
      const filter_r25 = i0.ɵɵrestoreView(_r24).filter;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectedDropdownItem($event, filter_r25.data.comparatorData, "comparator"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, WgAdvancedFilterComponent_ng_template_17_ng_template_9_Conditional_2_Template, 2, 6, "input", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, WgAdvancedFilterComponent_ng_template_17_ng_template_9_Conditional_3_Template, 4, 8, "div", 52)(4, WgAdvancedFilterComponent_ng_template_17_ng_template_9_div_4_Template, 4, 3, "div", 47);
  }
  if (rf & 2) {
    const filter_r25 = ctx.filter;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("d-flex", !filter_r25.data.unitsData);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("col-sm-6", !filter_r25.data.unitsData);
    i0.ɵɵproperty("dropdownList", filter_r25.data.comparatorData)("userSelection", ctx_r1.selectedItem ? ctx_r1.selectedItem : filter_r25.data.comparatorData[0]);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!filter_r25.data.unitsData ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(filter_r25.data.unitsData ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.validationErrors[filter_r25.field] == null ? null : ctx_r1.validationErrors[filter_r25.field].showError);
  }
}
function WgAdvancedFilterComponent_ng_template_17_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43)(1, "label", 44);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "wg-date-input", 55);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function WgAdvancedFilterComponent_ng_template_17_ng_template_11_Template_wg_date_input_ngModelChange_4_listener($event) {
      const filter_r29 = i0.ɵɵrestoreView(_r28).filter;
      i0.ɵɵtwoWayBindingSet(filter_r29.data.from, $event) || (filter_r29.data.from = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("focusout", function WgAdvancedFilterComponent_ng_template_17_ng_template_11_Template_wg_date_input_focusout_4_listener() {
      const filter_r29 = i0.ɵɵrestoreView(_r28).filter;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.validateDate(filter_r29.data));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 43)(7, "label", 44);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "wg-date-input", 56);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function WgAdvancedFilterComponent_ng_template_17_ng_template_11_Template_wg_date_input_ngModelChange_10_listener($event) {
      const filter_r29 = i0.ɵɵrestoreView(_r28).filter;
      i0.ɵɵtwoWayBindingSet(filter_r29.data.to, $event) || (filter_r29.data.to = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("focusout", function WgAdvancedFilterComponent_ng_template_17_ng_template_11_Template_wg_date_input_focusout_10_listener() {
      const filter_r29 = i0.ɵɵrestoreView(_r28).filter;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.validateDate(filter_r29.data));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_16_0;
    let tmp_21_0;
    let tmp_23_0;
    let tmp_28_0;
    const category_r30 = ctx.category;
    const filter_r29 = ctx.filter;
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", filter_r29.field);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 14, (tmp_16_0 = filter_r29.data.customFromText) !== null && tmp_16_0 !== undefined ? tmp_16_0 : "ui_common_from"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", filter_r29.field + "_from")("id", filter_r29.field)("max", filter_r29.data.to);
    i0.ɵɵtwoWayProperty("ngModel", filter_r29.data.from);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(5, 16, (tmp_21_0 = filter_r29.data.customPlaceHolder) !== null && tmp_21_0 !== undefined ? tmp_21_0 : category_r30.name));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("for", filter_r29.field);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 18, (tmp_23_0 = filter_r29.data.customToText) !== null && tmp_23_0 !== undefined ? tmp_23_0 : "ui_common_to"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", filter_r29.field + "_to")("id", filter_r29.field)("min", filter_r29.data.from);
    i0.ɵɵtwoWayProperty("ngModel", filter_r29.data.to);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(11, 20, (tmp_28_0 = filter_r29.data.customPlaceHolder) !== null && tmp_28_0 !== undefined ? tmp_28_0 : category_r30.name));
  }
}
function WgAdvancedFilterComponent_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 27, 4);
    i0.ɵɵtemplate(2, WgAdvancedFilterComponent_ng_template_17_ng_container_2_Template, 2, 1, "ng-container", 20)(3, WgAdvancedFilterComponent_ng_template_17_ng_template_3_Template, 3, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(5, WgAdvancedFilterComponent_ng_template_17_ng_template_5_Template, 6, 10, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(7, WgAdvancedFilterComponent_ng_template_17_ng_template_7_Template, 12, 18, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor)(9, WgAdvancedFilterComponent_ng_template_17_ng_template_9_Template, 5, 9, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor)(11, WgAdvancedFilterComponent_ng_template_17_ng_template_11_Template, 12, 22, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("allow-overflow", ctx_r1.hasFilterTypeDate(ctx_r1.openedCategory == null ? null : ctx_r1.openedCategory.filter));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.advancedFilterConfig == null ? null : ctx_r1.advancedFilterConfig.groups);
  }
}
function WgAdvancedFilterComponent_ng_template_19_Template(rf, ctx) {
  if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 57)(1, "a", 35);
    i0.ɵɵlistener("click", function WgAdvancedFilterComponent_ng_template_19_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r31);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearFilters());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 58);
    i0.ɵɵlistener("click", function WgAdvancedFilterComponent_ng_template_19_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r31);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancel());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 59);
    i0.ɵɵlistener("click", function WgAdvancedFilterComponent_ng_template_19_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r31);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addFilter());
    });
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "ui_common_clear_filters"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 6, "ui_common_label_cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.isButtonDisabled(ctx_r1.filterForm));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 8, "ui_common_apply_filters"), " ");
  }
}
class WgSearchComponent {
  constructor() {
    // HTML placeholder and title string, should be translated
    this.title = 'search';
    this.debounceTime = 300;
    this.placeholder = 'search';
    this.typeahead = false;
    this.disabled = false;
    // Sets the showCleanButton option
    this.hasClearSearchOption = false;
    // The output (filtered objects) that can be displayed
    this.filterObjects = new EventEmitter();
    this.searchTermChange = new EventEmitter();
    this.searchIconClick = new EventEmitter();
    this.hasSearchIconClickObservers = false;
    this.modelChanged = new Subject();
    this.showSuggestion = false;
    this.showCleanButton = false;
    this.itemHoveredIndex = -1;
    this.searchTermConcat = '';
  }
  ngOnChanges() {
    this.hasSearchIconClickObservers = this.searchIconClick.observers.length > 0;
  }
  ngOnInit() {
    // Debouncing based on time between input
    this.modelChanged.pipe(debounceTime(this.debounceTime) // wait 300ms after the last event before emitting last event
    ).subscribe(model => {
      this.searchTerm = model;
      this.searchTermChange.emit(this.searchTerm);
      this.searchObjects();
    });
  }
  /*
    * Gets called when search term input changes.
  */
  changed(searchString) {
    this.modelChanged.next(searchString);
  }
  onSearchIconClick() {
    this.searchIconClick.emit(this.searchTerm);
  }
  onCleanIconClick() {
    this.changed('');
    this.showCleanButton = false;
  }
  inputChanged(event) {
    if (this.hasClearSearchOption) {
      this.showCleanButton = this.searchTerm?.length > 0;
    }
    if (this.typeahead) {
      this.showSuggestion = true;
      const splitSearchTerm = this.searchTerm.split(' ');
      this.items = this.filterKeys.filter(key => {
        return this.matchFilterKeys(key, splitSearchTerm[splitSearchTerm.length - 1]);
      });
    }
  }
  itemSelected(event, item) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const searchTermUpToItem = this.searchTerm.split(' ');
    searchTermUpToItem.pop();
    this.searchTermConcat = searchTermUpToItem.join(' ');
    if (this.searchTermConcat !== '') {
      this.searchTermConcat += ' ';
    }
    if (item) {
      this.searchTerm = this.searchTermConcat + item;
      this.changed(this.searchTerm);
      this.searchTermConcat = this.searchTerm;
      this.itemHoveredIndex = 0;
    }
    this.showSuggestion = false;
  }
  toggleTypeaheadHelp() {
    this.items = this.filterKeys;
    this.showSuggestion = !this.showSuggestion;
  }
  closeDropDown(event) {
    if (!this.typeahead) {
      return;
    }
    if (event.close) {
      this.showSuggestion = false;
    }
  }
  keydown(event) {
    if (!this.typeahead) {
      return;
    }
    let key = event.key.toLowerCase();
    // IE11 fix
    if (key === 'down') {
      key = 'arrowdown';
    }
    if (key === 'up') {
      key = 'arrowup';
    }
    if (key === 'esc') {
      key = 'escape';
    }
    switch (key) {
      case 'arrowdown':
        event.preventDefault();
        event.stopPropagation();
        if (this.itemHoveredIndex < this.items.length - 1) {
          this.itemHoveredIndex++;
        } else {
          this.itemHoveredIndex = 0;
        }
        break;
      case 'arrowup':
        event.preventDefault();
        event.stopPropagation();
        if (this.itemHoveredIndex > 0) {
          this.itemHoveredIndex--;
        } else {
          this.itemHoveredIndex = this.items.length - 1;
        }
        break;
      case 'tab':
        this.itemSelected(undefined, this.items[this.itemHoveredIndex]);
        setTimeout(() => {
          this.searchbox.nativeElement.focus();
        }, 1);
        break;
      case 'enter':
        this.showSuggestion = false;
        break;
      case 'escape':
        this.showSuggestion = false;
        break;
    }
  }
  matchFilterKeys(key, searchVal) {
    if (this.searchTerm !== '' && key.includes(searchVal)) {
      return true;
    }
    return false;
  }
  searchObjects() {
    const filtered = [];
    if (this.initObjects) {
      const length = this.initObjects.length;
      for (let i = 0; i < length; i++) {
        if (this.searchObject(this.initObjects[i])) {
          filtered.push(this.initObjects[i]);
        }
      }
    }
    this.filterObjects.emit(filtered);
  }
  searchObject(obj) {
    const length = this.filterKeys.length;
    let found = false;
    for (let i = 0; i < length; i++) {
      if (obj[this.filterKeys[i]] instanceof Array) {
        found = this.searchArray(obj[this.filterKeys[i]]);
      } else if (obj[this.filterKeys[i]] instanceof Object) {
        found = this.searchObject(obj[this.filterKeys[i]]);
      } else {
        if (obj[this.filterKeys[i]]) {
          found = obj[this.filterKeys[i]].toString().toUpperCase().includes(this.searchTerm.toUpperCase());
        }
      }
      if (found) {
        break;
      }
    }
    return found;
  }
  searchArray(arr) {
    const length = arr.length;
    let found = false;
    for (let i = 0; i < length; i++) {
      if (arr[i] instanceof Array) {
        found = this.searchArray(arr[i]);
      } else if (arr[i] instanceof Object) {
        found = this.searchObject(arr[i]);
      } else {
        if (arr[i]) {
          found = arr[i].toString().toUpperCase().includes(this.searchTerm.toUpperCase());
        }
      }
      if (found) {
        break;
      }
    }
    return found;
  }
  static {
    this.ɵfac = function WgSearchComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSearchComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgSearchComponent,
      selectors: [["wg-search"]],
      viewQuery: function WgSearchComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownMenu = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchbox = _t.first);
        }
      },
      inputs: {
        title: "title",
        debounceTime: "debounceTime",
        placeholder: "placeholder",
        typeahead: "typeahead",
        searchTerm: "searchTerm",
        initObjects: "initObjects",
        filterKeys: "filterKeys",
        disabled: "disabled",
        hasClearSearchOption: "hasClearSearchOption"
      },
      outputs: {
        filterObjects: "filterObjects",
        searchTermChange: "searchTermChange",
        searchIconClick: "searchIconClick"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 15,
      vars: 18,
      consts: [["searchbox", ""], ["dropdownMenu", ""], [3, "keydown", "ngClass"], [1, "wg-search"], [1, "input-group", 3, "clickOutside"], ["type", "text", 1, "input-small", 3, "ngModelChange", "input", "disabled", "title", "placeholder", "ngModel"], [1, "input-group-append", 3, "hidden"], ["type", "button", 1, "btn", "btn-secondary", "btn-sm", 3, "click", "disabled"], ["name", "search"], ["name", "close"], ["class", "input-group-append", 4, "ngIf"], ["class", "dropdown-menu", "style", "width: 100%", 3, "ngClass", 4, "ngIf"], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-secondary", "btn-sm", 3, "click"], ["name", "question-circle"], [1, "dropdown-menu", 2, "width", "100%", 3, "ngClass"], ["href", "#", "class", "dropdown-item", 3, "ngClass", "mousedown", 4, "ngFor", "ngForOf"], ["href", "#", 1, "dropdown-item", 3, "mousedown", "ngClass"]],
      template: function WgSearchComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 2);
          i0.ɵɵlistener("keydown", function WgSearchComponent_Template_div_keydown_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.keydown($event));
          });
          i0.ɵɵelementStart(1, "div", 3)(2, "div", 4);
          i0.ɵɵlistener("clickOutside", function WgSearchComponent_Template_div_clickOutside_2_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.closeDropDown($event));
          });
          i0.ɵɵelementStart(3, "input", 5, 0);
          i0.ɵɵpipe(5, "translate");
          i0.ɵɵpipe(6, "translate");
          i0.ɵɵtwoWayListener("ngModelChange", function WgSearchComponent_Template_input_ngModelChange_3_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.searchTerm, $event) || (ctx.searchTerm = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵlistener("input", function WgSearchComponent_Template_input_input_3_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.inputChanged($event));
          })("ngModelChange", function WgSearchComponent_Template_input_ngModelChange_3_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.changed($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "span", 6)(8, "button", 7);
          i0.ɵɵlistener("click", function WgSearchComponent_Template_button_click_8_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onSearchIconClick());
          });
          i0.ɵɵelement(9, "wg-icon", 8);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(10, "span", 6)(11, "button", 7);
          i0.ɵɵlistener("click", function WgSearchComponent_Template_button_click_11_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onCleanIconClick());
          });
          i0.ɵɵelement(12, "wg-icon", 9);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(13, WgSearchComponent_span_13_Template, 3, 0, "span", 10);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(14, WgSearchComponent_div_14_Template, 3, 4, "div", 11);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(15, _c2, ctx.typeahead, ctx.hasSearchIconClickObservers));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("disabled", ctx.disabled)("title", i0.ɵɵpipeBind1(5, 11, ctx.title))("placeholder", i0.ɵɵpipeBind1(6, 13, ctx.placeholder));
          i0.ɵɵtwoWayProperty("ngModel", ctx.searchTerm);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("hidden", ctx.hasClearSearchOption && ctx.showCleanButton);
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.disabled);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("hidden", !ctx.showCleanButton);
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.disabled);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.typeahead);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.typeahead);
        }
      },
      dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgModel, i4.WgIconComponent, i4.ClickOutsideDirective, i1.TranslatePipe],
      styles: ["wg-search .wg-search{width:100%}wg-search .wg-search>div.input-group{flex-wrap:nowrap;white-space:nowrap}wg-search .wg-search>div input{border-bottom-right-radius:0;border-top-right-radius:0;line-height:normal}wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary{border-bottom-left-radius:0;border-top-left-radius:0;cursor:default}wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary wg-icon{height:16px;line-height:0;width:16px}wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary wg-icon svg,wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary wg-icon svg path,wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary wg-icon svg circle{fill:#367b88;stroke:transparent}wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary wg-icon svg{height:16px;min-height:16px;min-width:16px;width:16px}wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary:hover:not([disabled]){color:#367b88}wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary:hover:not([disabled]) wg-icon svg,wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary:hover:not([disabled]) wg-icon svg path,wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary:hover:not([disabled]) wg-icon svg circle{fill:#367b88;stroke:transparent}wg-search .wg-dropdown.dropdown .input-group>.input-group-append>.btn.btn-secondary{cursor:pointer}wg-search .search-icon-clickable .wg-search .input-group-append:nth-of-type(1) .btn{cursor:pointer}wg-search .search-icon-clickable .wg-search .input-group-append:nth-of-type(1) .btn:hover:not([disabled]) wg-icon svg,wg-search .search-icon-clickable .wg-search .input-group-append:nth-of-type(1) .btn:hover:not([disabled]) wg-icon svg path,wg-search .search-icon-clickable .wg-search .input-group-append:nth-of-type(1) .btn:hover:not([disabled]) wg-icon svg circle{fill:#57c5d9;stroke:transparent}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSearchComponent, [{
    type: Component,
    args: [{
      selector: 'wg-search',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div [ngClass]=\"{ 'wg-dropdown dropdown': typeahead, 'search-icon-clickable': hasSearchIconClickObservers }\"\n  (keydown)=\"keydown($event)\">\n  <div class=\"wg-search\">\n    <div\n      class=\"input-group\"\n      (clickOutside)=\"closeDropDown($event)\">\n      <input #searchbox\n        class=\"input-small\"\n        type=\"text\"\n        [disabled]=\"disabled\"\n        [title]=\"title | translate\"\n        [placeholder]=\"placeholder | translate\"\n        [(ngModel)]=\"searchTerm\"\n        (input)=\"inputChanged($event)\"\n        (ngModelChange)=\"changed($event)\">\n      <span class=\"input-group-append\" [hidden]=\"hasClearSearchOption && showCleanButton\">\n        <button type=\"button\" class=\"btn btn-secondary btn-sm\"\n          [disabled]=\"disabled\"\n          (click)=\"onSearchIconClick()\">\n          <wg-icon name=\"search\"></wg-icon>\n        </button>\n      </span>\n      <span class=\"input-group-append\" [hidden]=\"!showCleanButton\">\n        <button type=\"button\" class=\"btn btn-secondary btn-sm\"\n          [disabled]=\"disabled\"\n          (click)=\"onCleanIconClick()\">\n          <wg-icon name=\"close\"></wg-icon>\n        </button>\n      </span>\n      <span *ngIf=\"typeahead\" class=\"input-group-append\">\n        <button type=\"button\" class=\"btn btn-secondary btn-sm\"\n          (click)=\"toggleTypeaheadHelp()\">\n          <wg-icon name=\"question-circle\"></wg-icon>\n        </button>\n      </span>\n    </div>\n  </div>\n  <div *ngIf=\"typeahead\"\n    #dropdownMenu\n    class=\"dropdown-menu\"\n    [ngClass]=\"{ show: showSuggestion }\"\n    style=\"width: 100%\">\n    <a *ngFor=\"let item of items; let i = index;\"\n      href=\"#\"\n      [ngClass]=\"{hover: i === itemHoveredIndex}\"\n      (mousedown)=\"itemSelected($event, item)\"\n      class=\"dropdown-item\">\n      {{item}}\n    </a>\n  </div>\n</div>\n",
      styles: ["wg-search .wg-search{width:100%}wg-search .wg-search>div.input-group{flex-wrap:nowrap;white-space:nowrap}wg-search .wg-search>div input{border-bottom-right-radius:0;border-top-right-radius:0;line-height:normal}wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary{border-bottom-left-radius:0;border-top-left-radius:0;cursor:default}wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary wg-icon{height:16px;line-height:0;width:16px}wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary wg-icon svg,wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary wg-icon svg path,wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary wg-icon svg circle{fill:#367b88;stroke:transparent}wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary wg-icon svg{height:16px;min-height:16px;min-width:16px;width:16px}wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary:hover:not([disabled]){color:#367b88}wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary:hover:not([disabled]) wg-icon svg,wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary:hover:not([disabled]) wg-icon svg path,wg-search .wg-search>.input-group>.input-group-append>.btn.btn-secondary:hover:not([disabled]) wg-icon svg circle{fill:#367b88;stroke:transparent}wg-search .wg-dropdown.dropdown .input-group>.input-group-append>.btn.btn-secondary{cursor:pointer}wg-search .search-icon-clickable .wg-search .input-group-append:nth-of-type(1) .btn{cursor:pointer}wg-search .search-icon-clickable .wg-search .input-group-append:nth-of-type(1) .btn:hover:not([disabled]) wg-icon svg,wg-search .search-icon-clickable .wg-search .input-group-append:nth-of-type(1) .btn:hover:not([disabled]) wg-icon svg path,wg-search .search-icon-clickable .wg-search .input-group-append:nth-of-type(1) .btn:hover:not([disabled]) wg-icon svg circle{fill:#57c5d9;stroke:transparent}\n"]
    }]
  }], () => [], {
    title: [{
      type: Input
    }],
    debounceTime: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    typeahead: [{
      type: Input
    }],
    searchTerm: [{
      type: Input
    }],
    initObjects: [{
      type: Input
    }],
    filterKeys: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    hasClearSearchOption: [{
      type: Input
    }],
    filterObjects: [{
      type: Output
    }],
    searchTermChange: [{
      type: Output
    }],
    searchIconClick: [{
      type: Output
    }],
    dropdownMenu: [{
      type: ViewChild,
      args: ['dropdownMenu']
    }],
    searchbox: [{
      type: ViewChild,
      args: ['searchbox', {
        static: true
      }]
    }]
  });
})();
class WgSearchModule {
  static {
    this.ɵfac = function WgSearchModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgSearchModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgSearchModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, WgIconModule, WgClickOutsideModule, TranslateModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgSearchModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, WgIconModule, WgClickOutsideModule, TranslateModule],
      declarations: [WgSearchComponent],
      exports: [WgSearchComponent]
    }]
  }], null, null);
})();
class WgAdvancedFilterChipsComponent {
  constructor() {
    this.filterRemoved = new EventEmitter();
    this.filterChipChanges = new EventEmitter();
    this.chips = [];
  }
  removeFilter(filter) {
    this.filterRemoved.emit(filter);
  }
  ngOnChanges(changes) {
    if (changes.chips && changes.chips.currentValue !== changes.chips.previousValue) {
      this.filterChipChanges.emit(changes.chips.currentValue);
    }
  }
  static {
    this.ɵfac = function WgAdvancedFilterChipsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgAdvancedFilterChipsComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgAdvancedFilterChipsComponent,
      selectors: [["wg-advanced-filter-chips"]],
      inputs: {
        chips: "chips"
      },
      outputs: {
        filterRemoved: "filterRemoved",
        filterChipChanges: "filterChipChanges"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 1,
      consts: [[1, "wg-chips"], ["class", "btn", 4, "ngFor", "ngForOf"], [1, "btn"], [1, "close", 3, "click"], ["name", "close"]],
      template: function WgAdvancedFilterChipsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, WgAdvancedFilterChipsComponent_span_1_Template, 4, 1, "span", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.chips);
        }
      },
      dependencies: [i2.NgForOf, i4.WgIconComponent],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgAdvancedFilterChipsComponent, [{
    type: Component,
    args: [{
      selector: 'wg-advanced-filter-chips',
      standalone: false,
      template: "<div class=\"wg-chips\">\n  <span class=\"btn\" *ngFor=\"let chip of chips\">\n    {{ chip.label }}\n    <a class=\"close\" (click)=\"removeFilter(chip)\">\n      <wg-icon name=\"close\"></wg-icon>\n    </a>\n  </span>\n</div>\n"
    }]
  }], null, {
    filterRemoved: [{
      type: Output
    }],
    filterChipChanges: [{
      type: Output
    }],
    chips: [{
      type: Input
    }]
  });
})();
var AdvancedFilterType;
(function (AdvancedFilterType) {
  AdvancedFilterType["checkbox"] = "checkbox";
  AdvancedFilterType["text"] = "text";
  AdvancedFilterType["date"] = "date";
  AdvancedFilterType["range"] = "range";
  AdvancedFilterType["dropdown"] = "dropdown";
  AdvancedFilterType["inputDropdownCombo"] = "inputDropdownCombo";
})(AdvancedFilterType || (AdvancedFilterType = {}));
var AdvancedFilterLabelType;
(function (AdvancedFilterLabelType) {
  AdvancedFilterLabelType["ICON"] = "ICON";
  AdvancedFilterLabelType["LABEL"] = "LABEL";
})(AdvancedFilterLabelType || (AdvancedFilterLabelType = {}));
class WgAdvancedFilterComponent {
  set config(config) {
    this.advancedFilterConfig = JSON.parse(JSON.stringify(config));
    this.advancedFilterConfig.groups.forEach((group, groupIndex) => {
      group.categories.forEach((category, categoryIndex) => {
        if (categoryIndex === 0 && groupIndex === 0) {
          // open first category
          this.openCategory(category);
        }
        category.filter = Array.isArray(category.filter) ? category.filter : [category.filter];
        category.filter.forEach(categoryFilter => {
          if (categoryFilter.type === AdvancedFilterType.date && !categoryFilter.data) {
            categoryFilter.data = {
              from: null,
              to: null
            };
          }
        });
      });
    });
    // refresh chips
    this.applyFilter(true);
  }
  constructor(translateService) {
    this.translateService = translateService;
    this.validationErrors = {};
    this.type = AdvancedFilterLabelType.ICON;
    this.labelText = 'Select Filter';
    this.filterChanged = new EventEmitter();
    this.configChange = new EventEmitter();
    this.isDialogOpen = false;
    this.filterType = AdvancedFilterType;
    this.advancedFilterLabelType = AdvancedFilterLabelType;
    this.subscription = new Subscription();
  }
  addFilter() {
    this.applyFilter();
    this.toggleDialog(false);
  }
  selectedDropdownItem(event, dropDownData, dropdownType) {
    if (dropdownType === 'comparator') {
      if (!this.selectedItem) {
        this.selectedItem = dropDownData[0];
      }
      this.selectedItem = dropDownData.find(item => item.active);
      this.selectedItem = this.selectedItem ? this.selectedItem : dropDownData[0];
    } else if (dropdownType === 'units') {
      if (!this.selectedUnitValue) {
        this.selectedUnitValue = dropDownData[0];
      }
      this.selectedUnitValue = dropDownData.find(item => item.active);
      this.selectedUnitValue = this.selectedUnitValue ? this.selectedUnitValue : dropDownData[0];
    }
  }
  applyFilter(suppressConfigChangeEvent) {
    if (!this.filterForm) {
      return;
    }
    const {
      newChips,
      selectedFields
    } = this.getSelectedItems(this.advancedFilterConfig.groups);
    if (this.chipsComponent) {
      this.chipsComponent.chips = newChips;
    }
    this.filterChanged.emit(selectedFields);
    if (!suppressConfigChangeEvent) {
      this.configChange.emit(this.advancedFilterConfig);
    }
    this.previousFormValue = this.filterForm.value;
  }
  clearFilters() {
    this.filterForm.resetForm();
  }
  cancel() {
    this.filterForm.resetForm(this.previousFormValue);
    this.toggleDialog(false);
  }
  categoryFilters(category) {
    const appliedFilters = [];
    category.filter.forEach(categoryFilter => {
      switch (categoryFilter.type) {
        case AdvancedFilterType.checkbox:
          appliedFilters.push(categoryFilter.data.filter(item => item.checked).map(item => this.translateService.instant(item.label)).join(', '));
          break;
        case AdvancedFilterType.text:
          appliedFilters.push(categoryFilter.data);
          break;
        case AdvancedFilterType.date:
          const dateValue = categoryFilter.data;
          appliedFilters.push(this.getDateText(dateValue));
          break;
        case AdvancedFilterType.range:
          const rangeValue = categoryFilter.data;
          appliedFilters.push(this.getRangeValue(rangeValue));
          break;
        case AdvancedFilterType.dropdown:
          appliedFilters.push(categoryFilter.data.filter(item => item.active).map(item => item.val).join(', '));
          break;
        case AdvancedFilterType.inputDropdownCombo:
          const comboData = categoryFilter.data;
          const comparator = comboData.comparatorData.filter(item => item.active).map(item => item.val).join(', ');
          const time = comboData.inputData;
          let filterStr = '';
          if (comparator && time) {
            filterStr = `${comparator} ${time}`;
          }
          if (comboData.unitsData) {
            const units = comboData.unitsData.filter(item => item.active).map(item => item.val).join(', ');
            filterStr += ` ${units}`;
          }
          if (filterStr) {
            appliedFilters.push(filterStr);
          }
          break;
      }
    });
    return appliedFilters.filter(applyFilter => applyFilter && applyFilter.trim()).join(', ');
  }
  hasFilterTypeDate(filters) {
    return filters.some(filter => filter.type === this.filterType.date);
  }
  ngOnChanges(changes) {
    if (changes.chipsComponent && changes.chipsComponent.currentValue !== changes.chipsComponent.previousValue) {
      const chipsComponent = changes.chipsComponent.currentValue;
      if (chipsComponent && chipsComponent.filterRemoved) {
        this.subscription.add(chipsComponent.filterRemoved.subscribe(this.removeFilter.bind(this)));
      }
    }
  }
  ngAfterViewInit() {
    if (this.chipsComponent && this.chipsComponent.filterChipChanges) {
      this.subscription.add(this.chipsComponent.filterChipChanges.pipe(delay(0)).subscribe(this.updateFilters.bind(this)));
      if (this.chipsComponent.chips.length) {
        this.chipsComponent.filterChipChanges.emit(this.chipsComponent.chips);
      }
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  openCategory(category) {
    this.openedCategory = category;
  }
  removeFilter(filterRemoved) {
    filterRemoved.fieldId.split('&').forEach(fieldId => {
      if (fieldId === 'Time') {
        this.filterForm.controls['perf_issues_enable_filter_enable'].reset();
      }
      this.filterForm.controls[fieldId].reset();
    });
    this.applyFilter();
  }
  updateFilters(chips) {
    if (!chips.length || !this.filterForm) {
      return;
    }
    const updateFilter = chip => {
      if (chip.inputType === AdvancedFilterType.checkbox) {
        if (Array.isArray(chip.value)) {
          chip.fieldId.split('&').forEach(fieldId => {
            this.filterForm.controls[fieldId]?.setValue(true);
          });
        } else {
          this.filterForm.controls[chip.fieldId]?.setValue(true);
        }
      } else if (chip.inputType === AdvancedFilterType.date) {
        const dateOb = chip.value;
        chip.fieldId.split('&').forEach(fieldId => {
          const val = fieldId.indexOf('to') > -1 ? dateOb.to : fieldId.indexOf('from') > -1 ? dateOb.from : '';
          this.filterForm.controls[fieldId]?.setValue(val);
        });
      } else {
        this.filterForm.controls[chip.fieldId]?.setValue(chip.value);
      }
    };
    chips.forEach(updateFilter);
    this.applyFilter();
  }
  toggleDialog(isOpen = !this.isDialogOpen) {
    this.isDialogOpen = isOpen;
  }
  validateDate(date) {
    if (!isNaN(date.from) || !moment(date.from).isValid()) {
      date.from = null;
    }
    if (!isNaN(date.to) || !moment(date.to).isValid()) {
      date.to = null;
    }
  }
  createChipValue(groupName, categoryName, option, fieldId) {
    groupName = groupName ? this.translateService.instant(groupName) : null;
    categoryName = this.translateService.instant(categoryName);
    option = this.translateService.instant(option);
    return {
      fieldId,
      label: `${this.getGroupName(groupName)}${categoryName}: ${option}`
    };
  }
  getSelectedItems(groups) {
    // Deep clone
    groups = JSON.parse(JSON.stringify(groups)) || [];
    let newChips = [];
    const selectedFields = [];
    groups.forEach(group => {
      group.categories.forEach(category => {
        category.filter.forEach(categoryFilter => {
          // Type checkbox
          if (categoryFilter.type === AdvancedFilterType.checkbox) {
            const checkboxes = categoryFilter.data;
            const selectedCheckboxes = checkboxes.filter(checkbox => !!checkbox.checked).map(checkbox => checkbox.value).reduce((previousValue, currentValue) => previousValue.concat(Array.isArray(currentValue) ? currentValue : [currentValue]), []);
            if (selectedCheckboxes.length) {
              selectedFields.push({
                categoryId: `${this.getGroupName(group.name)}${category.name}`,
                id: `${group.id}.${category.id}.${categoryFilter.id}`,
                field: categoryFilter.field,
                value: selectedCheckboxes,
                type: AdvancedFilterType.checkbox
              });
              checkboxes.forEach(checkbox => {
                if (checkbox.checked && categoryFilter.field !== 'perf_issues_enable_filter') {
                  newChips.push(this.createChipValue(group.name, category.name, checkbox.label, `${categoryFilter.field}_${checkbox.value}`));
                }
              });
            }
          }
          // Type search
          if (categoryFilter.type === AdvancedFilterType.text && categoryFilter.data) {
            selectedFields.push({
              categoryId: `${this.getGroupName(group.name)}${category.name}`,
              id: `${group.id}.${category.id}.${categoryFilter.id}`,
              field: categoryFilter.field,
              value: categoryFilter.data,
              type: AdvancedFilterType.text
            });
            newChips.push(this.createChipValue(group.name, category.name, categoryFilter.data, categoryFilter.field));
          }
          // Type date
          if (categoryFilter.type === AdvancedFilterType.date && (categoryFilter.data.from || categoryFilter.data.to)) {
            selectedFields.push({
              categoryId: `${group.name ? group.name + ' ' : ''}${category.name}`,
              id: `${group.id}.${category.id}.${categoryFilter.id}`,
              field: categoryFilter.field,
              value: categoryFilter.data,
              type: AdvancedFilterType.date
            });
            const dateValue = categoryFilter.data;
            const text = this.getDateText(dateValue);
            const fieldId = `${categoryFilter.field}_from&${categoryFilter.field}_to`;
            newChips.push(this.createChipValue(group.name, category.name, text, fieldId));
          }
          if (categoryFilter.type === AdvancedFilterType.range && (categoryFilter.data.rangeFrom || categoryFilter.data.rangeTo)) {
            selectedFields.push({
              categoryId: `${group.name ? group.name + ' ' : ''}${category.name}`,
              id: `${group.id}.${category.id}.${categoryFilter.id}`,
              field: categoryFilter.field,
              value: categoryFilter.data,
              type: AdvancedFilterType.range
            });
            const rangeValue = categoryFilter.data;
            const text = this.getRangeValue(rangeValue);
            const fieldId = `${categoryFilter.field}_from&${categoryFilter.field}_to`;
            newChips.push(this.createChipValue(group.name, category.name, text, fieldId));
          }
          if (categoryFilter.type === AdvancedFilterType.inputDropdownCombo && categoryFilter.data.inputData) {
            const enableFilter = selectedFields.some(item => item.field === 'perf_issues_enable_filter');
            selectedFields.push({
              categoryId: `${group.name ? group.name + ' ' : ''}${category.name}`,
              id: `${group.id}.${category.id}.${categoryFilter.id}`,
              field: categoryFilter.field,
              value: categoryFilter.data,
              type: AdvancedFilterType.inputDropdownCombo
            });
            const comboData = categoryFilter.data;
            const comparatorValues = comboData.comparatorData.filter(item => item.active).map(item => item.val);
            const inputValue = comboData.inputData;
            let chipText = `${comparatorValues[0]} ${inputValue}`;
            if (comboData.unitsData) {
              const filteredUnitValues = comboData.unitsData.filter(item => item.active).map(item => item.val);
              chipText += ` ${filteredUnitValues[0]}`;
            }
            if (enableFilter) {
              newChips.push(this.createChipValue(group.name, category.name, chipText, categoryFilter.field));
            }
          }
        });
      });
    });
    return {
      newChips,
      selectedFields
    };
  }
  hasValidationError() {
    for (const key in this.validationErrors) {
      if (this.validationErrors[key].showError) {
        return true;
      }
    }
    return false;
  }
  isButtonDisabled(filterForm) {
    if (filterForm) {
      return filterForm.invalid || this.hasValidationError();
    }
    return false;
  }
  getDateText(dateValue) {
    let label = '';
    if (dateValue.from || dateValue.to) {
      if (dateValue.from === dateValue.to) {
        label += dateValue.from;
      } else {
        if (dateValue.from) {
          label += `${this.translateService.instant(dateValue.customFromLabel ?? 'ui_common_from')} ${dateValue.from} `;
        }
        if (dateValue.to) {
          label += `${this.translateService.instant(dateValue.customToLabel ?? 'ui_common_to')} ${dateValue.to}`;
        }
      }
    }
    return label;
  }
  getRangeValue(rangeValue) {
    let label = '';
    if (rangeValue.rangeFrom && rangeValue.rangeTo) {
      label += `${this.translateService.instant(rangeValue.fromLabel)} `;
      label += `${this.translateService.instant(rangeValue.rangeFrom)} `;
      label += `${this.translateService.instant(rangeValue.toLabel)} `;
      label += `${this.translateService.instant(rangeValue.rangeTo)}`;
    } else if (rangeValue.rangeFrom) {
      label += `${this.translateService.instant(rangeValue.fromLabel)} `;
      label += `${this.translateService.instant(rangeValue.rangeFrom)}`;
    } else if (rangeValue.rangeTo) {
      label += `${this.translateService.instant(rangeValue.toLabel)} `;
      label += `${this.translateService.instant(rangeValue.rangeTo)}`;
    }
    return label;
  }
  getGroupName(groupName) {
    return groupName ? `${groupName} ` : '';
  }
  setCategoryFilters(filterData, isChecked) {
    filterData.forEach(input => input.checked = isChecked);
  }
  validateTimeInput(input, field) {
    const pattern = new RegExp("^[0-9]*$");
    this.validationErrors[field] = {
      showError: false
    };
    if (input !== null && !pattern.test(input)) {
      this.validationErrors[field] = {
        showError: true
      };
    }
  }
  validateInput(event, field) {
    const pattern = new RegExp("^(100|[1-9]?[0-9]|)$");
    this.validationErrors[field] = {
      showError: false
    };
    if (event !== null && !pattern.test(event)) {
      this.validationErrors[field] = {
        showError: true
      };
    }
  }
  static {
    this.ɵfac = function WgAdvancedFilterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgAdvancedFilterComponent)(i0.ɵɵdirectiveInject(i1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WgAdvancedFilterComponent,
      selectors: [["wg-advanced-filter"]],
      viewQuery: function WgAdvancedFilterComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterForm = _t.first);
        }
      },
      inputs: {
        config: "config",
        chipsComponent: "chipsComponent",
        type: "type",
        labelText: "labelText"
      },
      outputs: {
        filterChanged: "filterChanged",
        configChange: "configChange"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 21,
      vars: 9,
      consts: [["filterLabel", ""], ["categoryTemplate", ""], ["formTemplate", ""], ["footerTemplate", ""], ["filterForm", "ngForm"], ["checkbox", ""], ["text", ""], ["range", ""], ["inputDropdownCombo", ""], ["date", ""], [1, "filter-button", 3, "click"], [4, "ngIf", "ngIfElse"], [1, "wg-dialog-lg", "no-margin-content", "advanced-filter-fixed", 3, "dialogClosedEvent", "showDialog"], ["dialog-title", ""], ["dialog-content", ""], [1, "filter-category-container"], [1, "filter-category"], [4, "ngTemplateOutlet"], [1, "filter-container"], ["name", "filter"], [4, "ngFor", "ngForOf"], ["class", "group-name", 4, "ngIf"], ["class", "category-name", 3, "opened", "click", 4, "ngFor", "ngForOf"], [1, "group-name"], [1, "category-name", 3, "click"], ["class", "selected-filters", 3, "title", 4, "ngIf"], [1, "selected-filters", 3, "title"], ["id", "filterForm"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "form-group", "for-checkbox", "wg-mb-15"], ["class", "category-filter-actions d-flex wg-mb-5", 4, "ngIf"], ["class", "form-check m-0", 4, "ngFor", "ngForOf"], [1, "category-filter-actions", "d-flex", "wg-mb-5"], [3, "click"], [1, "form-check", "m-0"], [1, "form-check-label", "mb-0", 3, "title"], ["form", "filterForm", "type", "checkbox", 1, "form-check-input", 3, "ngModelChange", "name", "ngModel"], [3, "name", "ngClass", "size", 4, "ngIf"], ["class", "table-status-label", 3, "title", 4, "ngIf"], [3, "name", "ngClass", "size"], [1, "table-status-label", 3, "title"], [1, "form-group"], [3, "for"], ["form", "filterForm", "type", "text", "maxlength", "50", 1, "form-control", 3, "ngModelChange", "placeholder", "name", "id", "ngModel"], ["form", "filterForm", "type", "text", "maxlength", "3", 1, "form-control", "col-sm-8", 3, "ngModelChange", "placeholder", "name", "id", "ngModel"], ["class", "text-danger", 4, "ngIf"], [1, "text-danger"], [1, "form-group", "for-dropdown"], ["name", "dropdown", 3, "selectedEvent", "dropdownList", "userSelection"], ["form", "filterForm", "type", "text", "maxlength", "50", 1, "form-control", "col-sm-6", 3, "placeholder", "name", "id", "ngModel"], [1, "form-group", "d-flex", "input-dropdown"], ["form", "filterForm", "type", "text", "maxlength", "50", 1, "form-control", "col-sm-6", 3, "ngModelChange", "placeholder", "name", "id", "ngModel"], [1, "col-sm-6", "wg-pr-0", 3, "selectedEvent", "dropdownList", "userSelection"], [3, "ngModelChange", "focusout", "name", "id", "max", "ngModel", "placeholder"], [3, "ngModelChange", "focusout", "name", "id", "min", "ngModel", "placeholder"], [1, "advanced-filter-footer", "wg-mt-15"], ["label", "Close", "type", "button", 1, "btn", "btn-secondary", 3, "click"], ["label", "Apply Filter", "type", "button", 1, "btn", "btn-primary", 3, "click", "disabled"]],
      template: function WgAdvancedFilterComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "a", 10);
          i0.ɵɵlistener("click", function WgAdvancedFilterComponent_Template_a_click_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggleDialog(true));
          });
          i0.ɵɵtemplate(1, WgAdvancedFilterComponent_ng_container_1_Template, 2, 0, "ng-container", 11)(2, WgAdvancedFilterComponent_ng_template_2_Template, 3, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "wg-dialog", 12);
          i0.ɵɵlistener("dialogClosedEvent", function WgAdvancedFilterComponent_Template_wg_dialog_dialogClosedEvent_4_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.cancel());
          });
          i0.ɵɵelementStart(5, "div", 13);
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "div", 14)(9, "div", 15)(10, "div", 16);
          i0.ɵɵtemplate(11, WgAdvancedFilterComponent_ng_container_11_Template, 1, 0, "ng-container", 17);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "div", 18);
          i0.ɵɵtemplate(13, WgAdvancedFilterComponent_ng_container_13_Template, 1, 0, "ng-container", 17)(14, WgAdvancedFilterComponent_ng_container_14_Template, 1, 0, "ng-container", 17);
          i0.ɵɵelementEnd()()()();
          i0.ɵɵtemplate(15, WgAdvancedFilterComponent_ng_template_15_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(17, WgAdvancedFilterComponent_ng_template_17_Template, 13, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(19, WgAdvancedFilterComponent_ng_template_19_Template, 10, 10, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const filterLabel_r32 = i0.ɵɵreference(3);
          const categoryTemplate_r33 = i0.ɵɵreference(16);
          const formTemplate_r34 = i0.ɵɵreference(18);
          const footerTemplate_r35 = i0.ɵɵreference(20);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.type === ctx.advancedFilterLabelType.ICON)("ngIfElse", filterLabel_r32);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("showDialog", ctx.isDialogOpen);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 7, ctx.advancedFilterConfig.title));
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("ngTemplateOutlet", categoryTemplate_r33);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", formTemplate_r34);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", footerTemplate_r35);
        }
      },
      dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2.NgSwitch, i2.NgSwitchCase, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.MaxLengthValidator, i3.NgModel, i3.NgForm, i4.WgIconComponent, i4.WgDropdownComponent, i4.WgDialogComponent, i5.DateInputComponent, i1.TranslatePipe],
      styles: ["[_nghost-%COMP%]{display:inline-block;vertical-align:middle}  .advanced-filter-fixed{width:680px!important}  .advanced-filter-fixed .ui-dialog-content,   .advanced-filter-fixed .p-dialog-content{height:400px!important;margin:0}.filter-button[_ngcontent-%COMP%]{margin:15px}.filter-category-container[_ngcontent-%COMP%]{display:flex;height:400px}.filter-category[_ngcontent-%COMP%]{overflow:auto;flex:1 0 230px;border-right:1px solid #d4d4d4}.filter-container[_ngcontent-%COMP%]{flex:1 0 auto;width:450px;padding:20px;display:flex;flex-direction:column}.filter-container[_ngcontent-%COMP%] > form[_ngcontent-%COMP%]{flex:1;overflow:auto}.filter-container[_ngcontent-%COMP%] > form.allow-overflow[_ngcontent-%COMP%]{overflow:visible}.filter-container[_ngcontent-%COMP%] > form[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]{padding:0 3px}.filter-container[_ngcontent-%COMP%] > form[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]   .category-filter-actions[_ngcontent-%COMP%]{gap:15px}.filter-container[_ngcontent-%COMP%] > form[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]   .form-check-input[_ngcontent-%COMP%]{height:100%;margin-top:0!important}.form-check-label[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;align-items:center;display:flex}.form-check-label[_ngcontent-%COMP%] > wg-icon[_ngcontent-%COMP%]{margin-right:5px}.group-name[_ngcontent-%COMP%]{margin:8px 20px 4px}.category-name[_ngcontent-%COMP%]{cursor:pointer;padding:8px 20px;transition:background-color .3s ease}.category-name[_ngcontent-%COMP%]:hover, .category-name.opened[_ngcontent-%COMP%]{background-color:#f2f2f2}.category-name.opened[_ngcontent-%COMP%]{border-right:4px solid #ff0000}.selected-filters[_ngcontent-%COMP%]{color:#7c7c7c;font-size:11px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;width:185px}.advanced-filter-footer[_ngcontent-%COMP%]{text-align:right}.advanced-filter-footer[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{line-height:34px;float:left}.advanced-filter-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-left:10px}.for-dropdown[_ngcontent-%COMP%]{min-height:50px}.input-dropdown[_ngcontent-%COMP%]{min-height:35px}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgAdvancedFilterComponent, [{
    type: Component,
    args: [{
      selector: 'wg-advanced-filter',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<!-- Note: -->\n<!-- Display filter icon default  -->\n<!-- Display filter icon when [type]=\"'ICON'\"  -->\n<!-- Display filter label/text [type]=\"'LABEL'\" when [labelText]=\"'Text want to display as label'\"  -->\n\n<a class=\"filter-button\" (click)=\"toggleDialog(true)\">\n  <ng-container *ngIf=\"type === advancedFilterLabelType.ICON;else filterLabel\">\n    <wg-icon name=\"filter\"></wg-icon>\n  </ng-container>\n  <ng-template #filterLabel>\n    <ng-container>\n        <a>{{labelText}}</a>\n      </ng-container>\n  </ng-template>\n</a>\n\n<wg-dialog class=\"wg-dialog-lg no-margin-content advanced-filter-fixed\"\n  [showDialog]=\"isDialogOpen\"\n  (dialogClosedEvent)=\"cancel()\">\n\n  <div dialog-title>{{ advancedFilterConfig.title | translate }}</div>\n\n  <div dialog-content>\n    <div class=\"filter-category-container\">\n      <!-- Category Section -->\n      <div class=\"filter-category\">\n        <ng-container *ngTemplateOutlet=\"categoryTemplate\"></ng-container>\n      </div>\n\n      <div class=\"filter-container\">\n        <!-- Filters Section -->\n        <ng-container *ngTemplateOutlet=\"formTemplate\"></ng-container>\n\n        <!-- Footer Section -->\n        <ng-container *ngTemplateOutlet=\"footerTemplate\"></ng-container>\n      </div>\n    </div>\n  </div>\n\n</wg-dialog>\n\n\n<!-- Category Template -->\n<ng-template #categoryTemplate>\n  <div *ngFor=\"let group of advancedFilterConfig?.groups\">\n    <h5 *ngIf=\"group.name\" class=\"group-name\">{{ group.name | translate }}</h5>\n    <div *ngFor=\"let category of group.categories\" (click)=\"openCategory(category)\"\n      [class.opened]=\"category === openedCategory\" class=\"category-name\">\n      {{ category.name | translate }}\n      <div class=\"selected-filters\" *ngIf=\"categoryFilters(category) as selectedFilters\" [title]=\"selectedFilters\">\n        {{ selectedFilters }}\n      </div>\n    </div>\n  </div>\n</ng-template>\n\n<!-- Form Template -->\n<ng-template #formTemplate>\n  <form #filterForm=\"ngForm\" id=\"filterForm\" [class.allow-overflow]=\"hasFilterTypeDate(openedCategory?.filter)\">\n\n    <ng-container *ngFor=\"let group of advancedFilterConfig?.groups\">\n      <ng-container *ngFor=\"let category of group.categories\">\n        <div [style.display]=\"category === openedCategory ? 'block' : 'none'\">\n          <ng-container *ngFor=\"let categoryFilter of category.filter\">\n            <!-- Switch Filter Type -->\n            <ng-container [ngSwitch]=\"categoryFilter.type\">\n              <!-- Case Checkbox -->\n              <ng-container *ngSwitchCase=\"filterType.checkbox\">\n                <ng-container *ngTemplateOutlet=\"checkbox; context: { group: group, category: category, filter: categoryFilter }\"></ng-container>\n              </ng-container>\n              <!-- Case Text -->\n              <ng-container *ngSwitchCase=\"filterType.text\">\n                <ng-container *ngTemplateOutlet=\"text; context: { group: group, category: category, filter: categoryFilter }\"></ng-container>\n              </ng-container>\n              <!-- Case Date -->\n              <ng-container *ngSwitchCase=\"filterType.date\">\n                <ng-container *ngTemplateOutlet=\"date; context: { group: group, category: category, filter: categoryFilter }\"></ng-container>\n              </ng-container>\n              <!-- Case Range-->\n              <ng-container\n                *ngSwitchCase=\"filterType.range\">\n                <ng-container\n                  *ngTemplateOutlet=\"range; context: { group: group, category: category, filter: categoryFilter }\">\n                </ng-container>\n              </ng-container>\n              <!-- Case input and dropdown combination -->\n              <ng-container\n                *ngSwitchCase=\"filterType.inputDropdownCombo\">\n                <ng-container\n                  *ngTemplateOutlet=\"inputDropdownCombo;\n                    context: { group: group, category: category, filter: categoryFilter }\">\n                </ng-container>\n              </ng-container>\n            </ng-container>\n          </ng-container>\n        </div>\n      </ng-container>\n    </ng-container>\n\n    <!-- Filter Checkbox Template -->\n    <ng-template #checkbox let-group=\"group\" let-category=\"category\" let-filter=\"filter\">\n      <div class=\"form-group for-checkbox wg-mb-15\">\n        <div class=\"category-filter-actions d-flex wg-mb-5\" *ngIf=\"!filter.hideCheckboxActions\">\n          <a (click)=\"setCategoryFilters(filter.data, true)\">\n            {{ 'select_all' | translate }}\n          </a>\n          <a (click)=\"setCategoryFilters(filter.data, false)\">\n            {{ 'clear_all' | translate }}\n          </a>\n        </div>\n        <div class=\"form-check m-0\" *ngFor=\"let option of filter.data\">\n          <label [title]=\"option.label | translate\" class=\"form-check-label mb-0\">\n            <input class=\"form-check-input\" form=\"filterForm\" type=\"checkbox\"\n              [name]=\"filter.field + '_' + option.value\"\n              [(ngModel)]=\"option.checked\">\n            <wg-icon *ngIf=\"option.icon\"\n              [name]=\"option.icon.name\"\n              [ngClass]=\"[option.icon.class ?? '']\"\n              [size]=\"option.icon.size ?? null\"></wg-icon>\n            {{ option.label | translate }}\n            <span *ngIf=\"option.tag\" class=\"table-status-label\" [title]=\"option.tag | translate\">\n              {{ option.tag | translate }}\n            </span>\n          </label>\n        </div>\n      </div>\n    </ng-template>\n\n    <!-- Text Template -->\n    <ng-template #text let-group=\"group\" let-category=\"category\" let-filter=\"filter\">\n      <div class=\"form-group\">\n        <label [for]=\"filter.field\">\n          {{ 'ui_common_search' | translate }}\n        </label>\n        <input class=\"form-control\" form=\"filterForm\" type=\"text\" maxlength=\"50\" [placeholder]=\"category.name | translate\"\n          [name]=\"filter.field\" [id]=\"filter.field\" [(ngModel)]=\"filter.data\">\n      </div>\n    </ng-template>\n\n    <!-- Range Template -->\n    <ng-template #range let-group=\"group\" let-category=\"category\" let-filter=\"filter\">\n      <div class=\"form-group\">\n        <label [for]=\"filter.field\">\n          {{ (filter.data.fromLabel ?? 'ui_common_search') | translate }}\n        </label>\n        <input\n          class=\"form-control col-sm-8\"\n          form=\"filterForm\"\n          type=\"text\"\n          maxlength=\"3\"\n          [placeholder]=\"filter.data.fromPlaceHolder\"\n          [name]=\"filter.field + '_from'\"\n          [id]=\"filter.field\"\n          [(ngModel)]=\"filter.data.rangeFrom\"\n          (ngModelChange)=\"validateInput($event, filter.field + '_from')\">\n        <div *ngIf=\"validationErrors[filter.field + '_from']?.showError\" class=\"text-danger\">\n          <div>\n            {{ filter.data.errorMessage | translate }}\n          </div>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label [for]=\"filter.field\">\n          {{ (filter.data.toLabel ?? 'ui_common_search') | translate }}\n        </label>\n        <input\n          class=\"form-control col-sm-8\"\n          form=\"filterForm\"\n          type=\"text\"\n          maxlength=\"3\"\n          [placeholder]=\"filter.data.toPlaceHolder\"\n          [name]=\"filter.field + '_to'\"\n          [id]=\"filter.field\"\n          [(ngModel)]=\"filter.data.rangeTo\"\n          (ngModelChange)=\"validateInput($event, filter.field + '_to')\">\n        <div *ngIf=\"validationErrors[filter.field + '_to']?.showError\" class=\"text-danger\">\n          <div>\n            {{ filter.data.errorMessage | translate }}\n          </div>\n        </div>\n      </div>\n    </ng-template>\n\n    <!-- Combination of Input and dropdown -->\n     <ng-template #inputDropdownCombo let-group=\"group\" let-category=\"category\" let-filter=\"filter\">\n      <div class=\"form-group for-dropdown\" [class.d-flex]=\"!filter.data.unitsData\">\n        <wg-dropdown\n          [class.col-sm-6]=\"!filter.data.unitsData\"\n          name=\"dropdown\"\n          [dropdownList]=\"filter.data.comparatorData\"\n          [userSelection]=\"selectedItem? selectedItem :filter.data.comparatorData[0]\"\n          (selectedEvent)=\"selectedDropdownItem($event, filter.data.comparatorData, 'comparator')\">\n        </wg-dropdown>\n\n        @if (!filter.data.unitsData) {\n          <input class=\"form-control col-sm-6\"\n            form=\"filterForm\"\n            type=\"text\"\n            maxlength=\"50\"\n            [placeholder]=\"filter.field | translate\"\n            [name]=\"filter.field\"\n            [id]=\"filter.field\"\n            [(ngModel)]=\"filter.data.inputData\"\n            (ngModelChange)=\"validateTimeInput($event, filter.field)\">\n        }\n      </div>\n      @if (filter.data.unitsData) {\n        <div class=\"form-group d-flex input-dropdown\">\n          <input class=\"form-control col-sm-6\"\n            form=\"filterForm\"\n            type=\"text\"\n            maxlength=\"50\"\n            [placeholder]=\"filter.field | translate\"\n            [name]=\"filter.field\"\n            [id]=\"filter.field\"\n            [(ngModel)]=\"filter.data.inputData\"\n            (ngModelChange)=\"validateTimeInput($event, filter.field)\">\n\n          <wg-dropdown\n            class=\"col-sm-6 wg-pr-0\"\n            [dropdownList]=\"filter.data.unitsData\"\n            [userSelection]=\"selectedUnitValue? selectedUnitValue :filter.data.unitsData[0]\"\n            (selectedEvent)=\"selectedDropdownItem($event, filter.data.unitsData, 'units')\">\n          </wg-dropdown>\n        </div>\n      }\n      <div *ngIf=\"validationErrors[filter.field]?.showError\" class=\"text-danger\">\n        <div>\n          {{ filter.data.errorMessage | translate }}\n        </div>\n      </div>\n     </ng-template>\n\n    <!-- Date Template -->\n    <ng-template #date let-group=\"group\" let-category=\"category\" let-filter=\"filter\">\n      <div class=\"form-group\">\n        <label [for]=\"filter.field\">\n          {{ (filter.data.customFromText ?? 'ui_common_from') | translate }}\n        </label>\n        <wg-date-input [name]=\"filter.field + '_from'\"\n          [id]=\"filter.field\"\n          [max]=\"filter.data.to\"\n          [(ngModel)]=\"filter.data.from\"\n          (focusout)=\"validateDate(filter.data)\"\n          [placeholder]=\"(filter.data.customPlaceHolder ?? category.name) | translate\">\n        </wg-date-input>\n      </div>\n      <div class=\"form-group\">\n        <label [for]=\"filter.field\">\n          {{ (filter.data.customToText ?? 'ui_common_to') | translate }}\n        </label>\n        <wg-date-input [name]=\"filter.field + '_to'\"\n          [id]=\"filter.field\"\n          [min]=\"filter.data.from\"\n          [(ngModel)]=\"filter.data.to\"\n          (focusout)=\"validateDate(filter.data)\"\n          [placeholder]=\"(filter.data.customPlaceHolder ?? category.name) | translate\">\n        </wg-date-input>\n      </div>\n    </ng-template>\n  </form>\n</ng-template>\n\n<!-- Footer Template -->\n<ng-template #footerTemplate>\n  <div class=\"advanced-filter-footer wg-mt-15\">\n    <a (click)=\"clearFilters()\">\n      {{ 'ui_common_clear_filters' | translate }}\n    </a>\n    <button label=\"Close\"\n            type=\"button\"\n            class=\"btn btn-secondary\"\n            (click)=\"cancel()\">\n      {{ 'ui_common_label_cancel' | translate }}\n    </button>\n    <button label=\"Apply Filter\"\n            type=\"button\"\n            class=\"btn btn-primary\"\n            (click)=\"addFilter()\"\n            [disabled]=\"isButtonDisabled(filterForm)\" >\n      {{ 'ui_common_apply_filters' | translate }}\n    </button>\n  </div>\n</ng-template>\n",
      styles: [":host{display:inline-block;vertical-align:middle}::ng-deep .advanced-filter-fixed{width:680px!important}::ng-deep .advanced-filter-fixed .ui-dialog-content,::ng-deep .advanced-filter-fixed .p-dialog-content{height:400px!important;margin:0}.filter-button{margin:15px}.filter-category-container{display:flex;height:400px}.filter-category{overflow:auto;flex:1 0 230px;border-right:1px solid #d4d4d4}.filter-container{flex:1 0 auto;width:450px;padding:20px;display:flex;flex-direction:column}.filter-container>form{flex:1;overflow:auto}.filter-container>form.allow-overflow{overflow:visible}.filter-container>form .form-group{padding:0 3px}.filter-container>form .form-group .category-filter-actions{gap:15px}.filter-container>form .form-group .form-check-input{height:100%;margin-top:0!important}.form-check-label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;align-items:center;display:flex}.form-check-label>wg-icon{margin-right:5px}.group-name{margin:8px 20px 4px}.category-name{cursor:pointer;padding:8px 20px;transition:background-color .3s ease}.category-name:hover,.category-name.opened{background-color:#f2f2f2}.category-name.opened{border-right:4px solid #ff0000}.selected-filters{color:#7c7c7c;font-size:11px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;width:185px}.advanced-filter-footer{text-align:right}.advanced-filter-footer a{line-height:34px;float:left}.advanced-filter-footer button{margin-left:10px}.for-dropdown{min-height:50px}.input-dropdown{min-height:35px}\n"]
    }]
  }], () => [{
    type: i1.TranslateService
  }], {
    config: [{
      type: Input
    }],
    chipsComponent: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    labelText: [{
      type: Input
    }],
    filterChanged: [{
      type: Output
    }],
    configChange: [{
      type: Output
    }],
    filterForm: [{
      type: ViewChild,
      args: ['filterForm']
    }]
  });
})();
class WgAdvancedFilterModule {
  static {
    this.ɵfac = function WgAdvancedFilterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WgAdvancedFilterModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: WgAdvancedFilterModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, WgIconModule, WgDropdownModule, WgDialogModule, TranslateModule, WgDateTimePickerModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WgAdvancedFilterModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, WgIconModule, WgDropdownModule, WgDialogModule, TranslateModule, WgDateTimePickerModule],
      declarations: [WgAdvancedFilterComponent, WgAdvancedFilterChipsComponent],
      exports: [WgAdvancedFilterComponent, WgAdvancedFilterChipsComponent]
    }]
  }], null, null);
})();
var ElasticSearchFilterType;
(function (ElasticSearchFilterType) {
  ElasticSearchFilterType["match"] = "match";
  ElasticSearchFilterType["term"] = "term";
  ElasticSearchFilterType["range"] = "range";
})(ElasticSearchFilterType || (ElasticSearchFilterType = {}));

/*
  This class helps to create an ElasticSearch query.
  As a query has a lot of options, we started with something simple to supply
  our needs by now, it will be improved over time.
*/
class ElasticSearchHelper {
  constructor({
    from,
    size,
    sort,
    filters,
    source
  }) {
    this._source = source;
    this.from = from;
    this.size = size;
    this.sort = sort;
    this.query = {
      bool: {
        filter: filters || []
      }
    };
  }
  addFiltersByAdvancedFilter(advancedFilterSelections) {
    if (!advancedFilterSelections) {
      return;
    }
    const filtersByCategory = advancedFilterSelections.reduce((accumulatedValue, currentValue) => {
      const hasEqualCategoryId = accumulatedValue.find(values => values.some(value => value.categoryId === currentValue.categoryId));
      if (hasEqualCategoryId) {
        hasEqualCategoryId.push(currentValue);
      } else {
        accumulatedValue.push([currentValue]);
      }
      return accumulatedValue;
    }, []);
    filtersByCategory.forEach(originalFilters => {
      const filtersToAdd = [];
      originalFilters.forEach(originalFilter => {
        const filter = {
          ...originalFilter
        };
        if (this.shouldBeNestedQuery(filter)) {
          filter.field = filter.field.split('#')[0];
          filtersToAdd.push(this.transformInNestedQuery(this.createFilters(filter), filter.field.split('.')[0]));
        } else {
          filtersToAdd.push(this.createFilters(filter));
        }
      });
      this.createQuery(filtersToAdd);
    });
  }
  createQuery(filtersToAdd) {
    if (filtersToAdd.length === 1) {
      this.query.bool.filter.push(...filtersToAdd[0]);
    } else {
      const wrapper = {
        bool: {
          should: flatten(filtersToAdd, true)
        }
      };
      this.query.bool.filter.push(wrapper);
    }
  }
  transformInNestedQuery(filtersToAdd, path) {
    return filtersToAdd.map(elasticSearchFilterClause => {
      const hasBool = !!elasticSearchFilterClause.bool;
      if (hasBool) {
        return {
          nested: {
            path,
            query: elasticSearchFilterClause
          }
        };
      } else {
        return {
          nested: {
            path,
            query: {
              bool: {
                must: [elasticSearchFilterClause]
              }
            }
          }
        };
      }
    });
  }
  shouldBeNestedQuery(filter) {
    return filter.field.endsWith('#nested');
  }
  addFilterClause(filterClause) {
    if (!filterClause) {
      return;
    }
    this.query.bool.filter.push(filterClause);
  }
  toString() {
    return JSON.stringify(this);
  }
  toObject() {
    // deep clone
    return JSON.parse(JSON.stringify(this));
  }
  static mapToPageable(elasticResponse) {
    if (!elasticResponse) {
      return;
    }
    const content = elasticResponse.searchResponse.hits.hits.map(hit => hit._source);
    const totalElements = elasticResponse.searchResponse.hits.total;
    const eTag = elasticResponse.etag;
    return {
      content,
      totalElements,
      eTag
    };
  }
  createElasticSearchFilter(field, filterValues, filterType) {
    const filters = [];
    const getFieldValueByType = fieldValue => {
      if (filterType === ElasticSearchFilterType.term) {
        const filter = {
          [field]: {
            value: fieldValue
          }
        };
        if (typeof fieldValue === 'string') {
          filter[field]['case_insensitive'] = true;
        }
        return filter;
      } else if (filterType === ElasticSearchFilterType.match) {
        return {
          [field]: {
            query: fieldValue,
            operator: 'AND'
          }
        };
      } else if (filterType === ElasticSearchFilterType.range) {
        const value = {};
        const {
          from,
          to
        } = filterValues;
        if (from) {
          const timezoneOffsetInMilliseconds = new Date(from).getTimezoneOffset() * 60 * 1000;
          value.gte = new Date(from).getTime() + timezoneOffsetInMilliseconds;
        }
        if (to) {
          const timezoneOffsetInMilliseconds = new Date(to).getTimezoneOffset() * 60 * 1000;
          const oneDayInMilliseconds = 8.64e+7;
          value.lte = new Date(to).getTime() + oneDayInMilliseconds + timezoneOffsetInMilliseconds - 1;
        }
        return {
          [field]: value
        };
      }
    };
    if (Array.isArray(filterValues)) {
      filterValues.forEach(filterValue => filters.push({
        [filterType]: getFieldValueByType(filterValue)
      }));
    } else {
      filters.push({
        [filterType]: getFieldValueByType(filterValues)
      });
    }
    return filters;
  }
  createFilters(filter) {
    const filterType = filter.type === AdvancedFilterType.checkbox ? ElasticSearchFilterType.term : filter.type === AdvancedFilterType.text ? ElasticSearchFilterType.match : filter.type === AdvancedFilterType.date ? ElasticSearchFilterType.range : null;
    if (!filterType) {
      return [];
    }
    const filtersToAdd = this.createElasticSearchFilter(filter.field, filter.value, filterType);
    if (filterType === ElasticSearchFilterType.term) {
      return [{
        bool: {
          should: [...filtersToAdd]
        }
      }];
    }
    return filtersToAdd;
  }
}

/*
 * Public API Surface of wg-search
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AdvancedFilterLabelType, AdvancedFilterType, ElasticSearchFilterType, ElasticSearchHelper, WgAdvancedFilterChipsComponent, WgAdvancedFilterComponent, WgAdvancedFilterModule, WgSearchComponent, WgSearchModule };
